/**
 * @generated SignedSource<<ba423a8e8f20768cec913400a3612667>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PresentationItemNew_presentation$data = {
  readonly description: string | null | undefined;
  readonly guestPresenterAvatarUrl: string;
  readonly presenter: {
    readonly firstName: string;
    readonly lastName: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserPrimaryPhotoNew_user">;
  } | null | undefined;
  readonly presenterFirstName: string | null | undefined;
  readonly presenterLastName: string | null | undefined;
  readonly prettyUrl: string;
  readonly rowId: string;
  readonly title: string;
  readonly updatedAt: string | null | undefined;
  readonly videoSourceUrl: string | null | undefined;
  readonly " $fragmentType": "PresentationItemNew_presentation";
};
export type PresentationItemNew_presentation$key = {
  readonly " $data"?: PresentationItemNew_presentation$data;
  readonly " $fragmentSpreads": FragmentRefs<"PresentationItemNew_presentation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PresentationItemNew_presentation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoSourceUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "presenterFirstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "presenterLastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "presenter",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserPrimaryPhotoNew_user"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "transform",
          "value": {
            "dpr": 3,
            "fo": "auto",
            "h": 32,
            "w": 32
          }
        }
      ],
      "kind": "ScalarField",
      "name": "guestPresenterAvatarUrl",
      "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":32,\"w\":32})"
    }
  ],
  "type": "Presentation",
  "abstractKey": null
};

(node as any).hash = "1f45455fc633101fec1baa84b5360811";

export default node;
